import React, { useEffect, useRef, useState } from 'react'
import { getGloThemeManager } from './ThemeManager'

const isSSR = () => typeof window === 'undefined' || !window.document
export function useThemeCoreLoaded(
  coreNames: Array<string>,
  fallbackCores?: Array<string>
): [
  boolean,
  boolean,
  (p_coreNames: Array<string>, p_fallbackCores?: Array<string>) => void,
  () => Boolean
] {
  const refLoadTM = useRef<any>(null)
  const [loaded, setLoaded] = useState(false)
  const [failed, setFailed] = useState(false)
  const refthemeCoreCallback = React.useRef((evt: CustomEvent<any>) => {
    checkCores()
  })
  const refStartLoadCallback = React.useRef((evt: CustomEvent<any>) => {
    checkCores()
  })

  const resetCores = (
    p_coreNames: Array<string>,
    p_fallbackCores?: Array<string>
  ) => {
    setFailed(false)
    setLoaded(false)
    getGloThemeManager()?.addCoreNames(
      p_coreNames ?? coreNames,
      p_fallbackCores ?? fallbackCores
    )

    checkCores()
  }

  const checkCores = (): Boolean => {
    // const activeCnt = coreNames.filter(
    //   (c) => GloThemeManager.coreStatus(c) == 'loaded'
    // )?.length
    // const failedCnt = coreNames.filter(
    //   (c) => GloThemeManager.coreStatus(c) == 'failed'
    // )?.length

    // if (failedCnt > 0) {
    //   setFailed(true)
    //   setLoaded(false)
    //   return true
    // }

    // if (activeCnt >= coreNames.length) {
    //   setLoaded(true)
    //   return true
    // }
    if (getGloThemeManager()?.loadstate == 2) {
      if (failed) {
        setFailed(false)
      }
      setLoaded(getGloThemeManager()?.loadstate == 2)
    }

    return getGloThemeManager()?.loadstate == 2
  }

  useEffect(() => {
    if (!isSSR()) return
    getGloThemeManager()?.addCoreNames(coreNames, fallbackCores)

    if (refthemeCoreCallback.current) {
      window.document.addEventListener(
        'themecore.loaded',
        refthemeCoreCallback.current
      )
    }

    if (refStartLoadCallback.current) {
      window.document.addEventListener(
        'themecore.update',
        refStartLoadCallback.current
      )
    }

    if (refLoadTM.current) {
      clearInterval(refLoadTM.current)
    }

    refLoadTM.current = setInterval(() => {
      if (checkCores()) {
        clearInterval(refLoadTM.current)
      }
    }, 100)

    checkCores()
    return () => {
      if (refLoadTM.current) {
        clearInterval(refLoadTM.current)
      }
      if (refthemeCoreCallback.current) {
        window.document.removeEventListener(
          'themecore.loaded',
          refthemeCoreCallback.current
        )
      }
      if (refStartLoadCallback.current) {
        window.document.removeEventListener(
          'themecore.update',
          refStartLoadCallback.current
        )
      }
    }
  }, [])

  return [loaded, failed, resetCores, checkCores]
}
